import React, { useState } from "react";
import { useL } from "@/lib/useL";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Sux1Logo } from "@/components/Sux1Logo";
import { PasswordInput } from "@/components/PasswordInput";

const inputCls = "w-full bg-transparent border border-border px-4 py-3 font-mono text-sm focus:outline-none focus:ring-1 focus:ring-[#002FA7] focus:border-[#002FA7]";

export default function ResetPassword() {
  const L = useL();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) return toast("Les deux mots de passe ne sont pas identiques.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success(data.message);
      nav("/login", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast(typeof d === "string" ? d : L("Lien invalide ou expiré.", "Invalid or expired link."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-8 lg:p-16" data-testid="reset-password-page">
      <Link to="/" className="mb-16"><Sux1Logo size="lg" /></Link>
      <div className="max-w-md w-full mx-auto">
        <div className="sux-marker mb-3">{L("Mot de passe oublié", "Forgot password")}</div>
        <h1 className="text-4xl sm:text-5xl font-black mb-8 leading-[0.95]">{L("Nouveau mot de passe.", "New password.")}</h1>
        {!token ? (
          <p className="text-sm text-muted-foreground" data-testid="reset-password-no-token">
            {L("Lien incomplet. Refaites une demande depuis la page", "Incomplete link. Make a new request from the")} <Link to="/login" className="text-[#002FA7] underline">{L("Connexion", "Login page")}</Link>.
          </p>
        ) : (
          <form onSubmit={onSubmit} className="space-y-5">
            <PasswordInput required minLength={6} value={pwd} onChange={(e) => setPwd(e.target.value)}
              placeholder={L("Nouveau mot de passe (6 caractères min.)", "New password (6 characters min.)")} className={inputCls} testid="reset-password-input" />
            <PasswordInput required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
              placeholder={L("Confirmer le mot de passe", "Confirm password")} className={inputCls} testid="reset-password-confirm-input" />
            <button type="submit" disabled={busy} data-testid="reset-password-submit"
              className="w-full bg-[#002FA7] text-white font-mono uppercase tracking-[0.25em] text-xs py-4 hover:bg-[#00227A] transition-colors disabled:opacity-50">
              {busy ? "…" : L("Enregistrer le mot de passe", "Save password")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
